<script>
	import options from './LinkSpot.options'
	export default options
</script>

<template>
	<article class="nlx-link-spot">
    
        <template v-if="props.href">
            <a :href="props.href" class="nlx-link-spot__click-layer"></a> 
        </template>

        <section class="nlx-link-spot__content-container">
            <div class="nlx-link-spot__image-container">
                <img :src="props.imageHref" :alt="props.title"/>
            </div>
            <h3 class="nlx-link-spot__card-title">{{props.title}}</h3>
            <p class="nlx-link-spot__card-text">{{props.description}}</p>

            <template v-for="(link, index) in props.links" :key="index">
                <a :href="link.linkHref" v-if="link.linkHref" class="nlx-link-spot__link">
                    <p>{{link.linkValue}}</p>
                    <div class="nlx-link-spot__link-svg-container">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 26">
                            <defs>
                                <clipPath id="clip-Artboard_5">
                                <rect width="60" height="26"/>
                                </clipPath>
                            </defs>
                            <g id="Artboard_5" data-name="Artboard – 5" clip-path="url(#clip-Artboard_5)">
                                <line id="Line_16" data-name="Line 16" x2="56" transform="translate(1.5 12.5)" fill="none" stroke="#1d1d1c" stroke-linecap="round" stroke-width="3"/>
                                <line id="Line_17" data-name="Line 17" x2="10.678" y2="10.678" transform="translate(46.822 1.822)" fill="none" stroke="#1d1d1c" stroke-linecap="round" stroke-width="3"/>
                                <line id="Line_18" data-name="Line 18" x2="10.678" y2="10.678" transform="translate(46.822 1.822)" fill="none" stroke="#1d1d1c" stroke-linecap="round" stroke-width="3"/>
                                <line id="Line_19" data-name="Line 19" y1="10.678" x2="10.678" transform="translate(46.822 12.822)" fill="none" stroke="#1d1d1c" stroke-linecap="round" stroke-width="3"/>
                            </g>
                        </svg>
                    </div>
                </a> 
            </template>

        </section>

    </article>
</template>
